<div class="content">
     <mat-tab-group>
        <mat-tab label="Sensor Data">
            <ag-grid-angular 
            class="ag-theme-alpine" 
            style="height: 73vh; width: 83vw; margin-left: 6px;" 
            [columnDefs]="sensorColDefs"
            [defaultColDef]="defaultColDef" 
            [gridOptions]="gridOptions"
            [rowData]="sensorRowData"
            (gridReady)="onSensorGridReady($event)"
            (rowDoubleClicked)="onSensorRowDoubleClick($event)">
            </ag-grid-angular>
        </mat-tab>
        <mat-tab label="Biological Data"> 
            <ag-grid-angular 
            class="ag-theme-alpine" 
            style="height: 73vh; width: 83vw; margin-left: 6px;" 
            [columnDefs]="bioColDefs"
            [defaultColDef]="defaultColDef" 
            [gridOptions]="gridOptions"
            [rowData]="biologicalRowData"
            (gridReady)="onBiologicalGridReady($event)"
            (rowDoubleClicked)="onBiologicalRowDoubleClick($event)">
            </ag-grid-angular>
        </mat-tab>
        <mat-tab label="Physicochemical Data"> 
            <ag-grid-angular 
            class="ag-theme-alpine" 
            style="height: 73vh; width: 83vw; margin-left: 6px;" 
            [columnDefs]="physicoColDefs"
            [defaultColDef]="defaultColDef" 
            [gridOptions]="gridOptions"
            [rowData]="physicochemicalRowData"
            (gridReady)="onPhysicochemicalGridReady($event)"
            (rowDoubleClicked)="onPhysicochemicalRowDoubleClick($event)">
            </ag-grid-angular>
        </mat-tab>
        <mat-tab label="Literature Data"> 
            <ag-grid-angular 
            class="ag-theme-alpine" 
            style="height: 73vh; width: 83vw; margin-left: 6px;" 
            [columnDefs]="litColDefs"
            [defaultColDef]="defaultColDef" 
            [gridOptions]="gridOptions"
            [rowData]="literatureRowData"
            (gridReady)="onLiteratureGridReady($event)"
            (rowDoubleClicked)="onLiteratureRowDoubleClick($event)">
            </ag-grid-angular>
        </mat-tab>
    </mat-tab-group>
</div>
